import React, { useEffect, useState } from "react";
import "./classStart.scss";
import { getClassStartTime, sendStartTime, getClassSummary, sendActions, submitZoomLinkForClassStart, submitClassCancelReasons } from "../../../actions/tutorFeedActions";
import { connect } from "react-redux";
import $ from "jquery";
import Snackbar from "../../Snackbar";

function ClassStart2(props) {

    const [timeLeft, setTimeLeft] = useState();
    const [startButton, setstartButton] = useState(true);
    const [programNameState, setprogramNameState] = useState();
    const [classStartData, setclassStartData] = useState('');
    const [count, setcount] = useState(true);
    const [programId, setprogramId] = useState("");
    const [courseId, setcourseId] = useState("");
    const [timeStampHistory, settimeStampHistory] = useState([]);
    const [classesInfo, setclassesInfo] = useState([]);
    const [overAllSummary, setoverAllSummary] = useState("");
    const [timeSummary, settimeSummary] = useState([]);
    const [makingArray, setmakingArray] = useState({
        1: 2,
        2: 2,
        3: 2,
        4: 2
    });
    const [filter, setfilter] = useState("week");
    const [loading, setloading] = useState(true);
    const [apiError, setapiError] = useState('');
    const [alreadystartError, setalreadystartError] = useState("");
    const [zoomLink, setzoomLink] = useState(null);
    const [timeOver, settimeOver] = useState(false);
    const [postBtnClicked, setpostBtnClicked] = useState(false);
    const [classCancelReasons, setclassCancelReasons] = useState([]);
    const [teacherId, setteacherId] = useState('');
    const [studentsArray, setstudentsArray] = useState([]);
    const [snackbarMessage, setsnackbarMessage] = useState("");
    const [snackbarColor, setsnackbarColor] = useState("#01ac8a");
    const [snackbar, setsnackbar] = useState(false);
    const [btnLoader, setbtnLoader] = useState(false);

    const calculateTimeLeft = (time) => {
        const difference = +new Date(time) - +new Date();
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        }
        return timeLeft;
    };
    // const calculateTimeLeft = () => {
    //     let year = new Date().getFullYear();
    //     const difference = +new Date("2021-08-10 14:00:00") - +new Date();
    //     let timeLeft = {};

    //     if (difference > 0) {
    //         timeLeft = {
    //             days: Math.floor(difference / (1000 * 60 * 60 * 24)),
    //             hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
    //             minutes: Math.floor((difference / 1000 / 60) % 60),
    //             seconds: Math.floor((difference / 1000) % 60),
    //         };
    //     }
    //     return timeLeft;
    // };

    // const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());



    useEffect(() => {
        const difference = +new Date(classStartData.datetime && classStartData.datetime.replace(/-/g, "/")) - +new Date();
        if (difference > 0) {
            // debugger;
            setTimeout(() => {
                setTimeLeft(calculateTimeLeft(classStartData.datetime && classStartData.datetime.replace(/-/g, "/")));
                // setTimeLeft(calculateTimeLeft("2021-08-11 11:49:00"));
            }, 1000);
        }
        else {
            setstartButton(false);
        }
        // if(loading !== true && difference < 0 && postBtnClicked) {
        //     debugger;
        //     window.open(zoomLink, '_blank');
        //     // settimeOver(true)
        // }
    });

    if (props.programNameState.programName !== programNameState) {
        const { programNameState } = props;
        setloading(true)
        setprogramNameState(programNameState.programName);
        setprogramId(programNameState.program);
        setcourseId(programNameState.courseId);
        setcount(true);
        setstartButton(true);

        var tutorData = JSON.parse(localStorage.getItem("loginData"));
        if (tutorData != null) {
            setteacherId(tutorData.user.id);
            setstudentsArray(tutorData.teacher_students[programNameState.programName]);
            //To get Class Start Time
            props.getClassStartTime(programNameState.program, tutorData.user.id, programNameState.courseId, tutorData.user.client_id , programNameState.slotId)
                .then((res) => {
                    if (res.status == "success" && typeof res.message === "undefined") {
                        setclassStartData(res.result);
                        setcount(true);
                        setstartButton(true);
                        debugger;
                        calculateTimeLeft(res.result.datetime);
                        setloading(false);
                        setzoomLink(res.zoomlink);
                    }
                    else if (res.status == "success" && typeof res.message !== "undefined") {
                        setapiError(res.message);
                        setloading(false);
                        debugger;
                    }
                    else {
                        debugger;
                        setloading(false);
                        setapiError(res.message);
                    }
                })
                .catch((err) => {
                    debugger;
                    if (err.data.status == "error") {
                        debugger;
                    }
                })

            //To get Summary and All
            props.getClassSummary(programNameState.program, tutorData.user.id, programNameState.courseId, filter)
                .then((res) => {
                    if (res.status == "success") {
                        settimeStampHistory(res.result['timeStampHistory']);
                        setclassesInfo(res.result['timeStampHistory']);
                        // settimeSummary(res.result['timeStampSummary']);
                        // setoverAllSummary(res.result['overAllSummary']);
                        console.log("API", res.result);

                        var overAllSummaryMapped = res.result['overAllSummary'].map(item => (
                            {
                                [item.label]: item.count
                            }))

                        setoverAllSummary(Object.assign({}, ...overAllSummaryMapped));

                        setmakingArray({ ...makingArray, ...res.result['timeStampSummary'] });
                        var timeStampSummaryMapped = res.result['timeStampSummary'].map(item => (
                            {
                                [item.label]: item.count
                            }))
                        console.log("MAPPED", timeStampSummaryMapped);
                        settimeSummary(Object.assign({}, ...timeStampSummaryMapped));
                        debugger;
                    }
                    else {
                        debugger;
                    }
                })
                .catch((err) => {
                    debugger;
                    if (err.data.status == "error") {
                        debugger;
                    }
                })
        }
    }



    const timerComponents = [];


    if (typeof timeLeft !== "undefined") {
        // debugger;
        Object.keys(timeLeft).forEach((interval) => {
            if (!timeLeft[interval]) {
                return;
            }
            console.log("Time Left", timeLeft)
            if (timeLeft.days == 0 && timeLeft.hours == 0 && timeLeft.minutes <= 10 && count) {
                debugger;
                setstartButton(false);
                setcount(false);
            }
            timerComponents.push(
                <span className="ml-2 mt-2 font-weight-bold">
                    {timeLeft[interval]} {interval}{" "}
                </span>
            );
        });
        if (Object.keys(timeLeft).length === 0 && timeLeft.constructor === Object && timerComponents.length == 0 && postBtnClicked) {
            debugger;
            setpostBtnClicked(false)
            window.open(zoomLink, '_blank');
            setTimeLeft('');
            $('#myModalWait').modal('hide');
        }
    }

    const postTime = () => {
        const timeDifference = +new Date(classStartData.datetime.replace(/-/g, "/")) - +new Date();
        var tutorData = JSON.parse(localStorage.getItem("loginData"));
        if (tutorData != null && zoomLink != null && timeDifference < 0) {
            debugger;
            props.sendStartTime(programId, tutorData.user.id, courseId, props.programNameState.slotId)
                .then((res) => {
                    debugger;
                    setapiError("Class Started")
                    window.open(zoomLink, '_blank');
                    props.getClassSummary(programId, tutorData.user.id, courseId, filter)
                        .then((res2) => {
                            if (res2.status == "success") {
                                settimeStampHistory(res2.result['timeStampHistory']);
                                setclassesInfo(res2.result['timeStampHistory']);
                                debugger;
                            }
                            else {
                                debugger;
                            }
                        })
                        .catch((err) => {
                            debugger;
                            if (err.data.status == "error") {
                                debugger;
                            }
                        })
                })
                .catch((err) => {
                    debugger;
                })
        }
        else if (tutorData != null && zoomLink != null && timeDifference > 0) {
            debugger;
            setpostBtnClicked(true);
            props.sendStartTime(programId, tutorData.user.id, courseId, props.programNameState.slotId)
                .then((res) => {
                    debugger;
                    setapiError("Class Started")
                    // window.open(zoomLink, '_blank');
                    props.getClassSummary(programId, tutorData.user.id, courseId, filter)
                        .then((res2) => {
                            if (res2.status == "success") {
                                settimeStampHistory(res2.result['timeStampHistory']);
                                setclassesInfo(res2.result['timeStampHistory']);
                                debugger;
                            }
                            else {
                                debugger;
                            }
                        })
                        .catch((err) => {
                            debugger;
                            if (err.data.status == "error") {
                                debugger;
                            }
                        })
                })
                .catch((err) => {
                    debugger;
                })
            $('#myModalWait').modal('show');
        }
        else {
            debugger;
            $('#myModal').modal('show');
        }
    }

    const takeAction = (itemId, action) => {
        // $('#myModal').modal('show');
        var filter = classesInfo.filter(item => item.time_id !== itemId);
        timeStampHistory.map((item, index) => {
            debugger;
            if (timeStampHistory[index]['time_id'] === itemId) {
                debugger;
                timeStampHistory[index]['label'] = action;
            }
        })
        timeSummary[action] = +timeSummary[action] + 1;
        debugger;
        setclassesInfo(filter);
    }

    const doFiler = (e, itemId) => {
        // var filter = classesInfo.filter(item => item.time_id !== itemId);
        timeStampHistory.map((item, index) => {
            debugger;
            if (timeStampHistory[index]['time_id'] === itemId) {
                debugger;
                timeStampHistory[index]['label'] = parseInt(e.target.value);
            }
        })

        var tutorData = JSON.parse(localStorage.getItem("loginData"));
        if (tutorData != null) {
            props.sendActions(programId, tutorData.user.id, courseId, itemId, e.target.value)
                .then((res) => {
                    debugger;
                    props.getClassSummary(programId, tutorData.user.id, courseId, filter)
                        .then((res2) => {
                            if (res2.status == "success") {
                                settimeStampHistory(res2.result['timeStampHistory']);
                                setclassesInfo(res2.result['timeStampHistory']);
                                var overAllSummaryMapped = res2.result['overAllSummary'].map(item => (
                                    {
                                        [item.label]: item.count
                                    }))

                                setoverAllSummary(Object.assign({}, ...overAllSummaryMapped));

                                setmakingArray({ ...makingArray, ...res2.result['timeStampSummary'] });
                                var timeStampSummaryMapped = res2.result['timeStampSummary'].map(item => (
                                    {
                                        [item.label]: item.count
                                    }))
                                console.log("MAPPED", timeStampSummaryMapped);
                                settimeSummary(Object.assign({}, ...timeStampSummaryMapped));
                                debugger;
                            }
                            else {
                                debugger;
                            }
                        })
                        .catch((err) => {
                            debugger;
                            if (err.data.status == "error") {
                                debugger;
                            }
                        })
                })
                .catch((err) => {
                    debugger;
                })
        }
        // timeSummary[parseInt(e.target.value)] = +timeSummary[parseInt(e.target.value)] + 1;
        debugger;
        // setclassesInfo(filter);
        settimeStampHistory([...timeStampHistory])
    }

    const submitZoom = () => {
        var tutorData = JSON.parse(localStorage.getItem("loginData"));
        if (tutorData != null) {
            props.submitZoomLinkForClassStart(programId, tutorData.user.id, courseId, zoomLink)
                .then((res) => {
                    $('#myModal').modal('hide');
                })
        }
    }

    const historyFilter = (e) => {
        setfilter(e.target.value);
        var tutorData = JSON.parse(localStorage.getItem("loginData"));
        if (tutorData != null) {
            props.getClassSummary(programId, tutorData.user.id, courseId, e.target.value)
                .then((res2) => {
                    if (res2.status == "success") {
                        settimeStampHistory(res2.result['timeStampHistory']);
                        setclassesInfo(res2.result['timeStampHistory']);
                        var overAllSummaryMapped = res2.result['overAllSummary'].map(item => (
                            {
                                [item.label]: item.count
                            }))

                        setoverAllSummary(Object.assign({}, ...overAllSummaryMapped));

                        var timeStampSummaryMapped = res2.result['timeStampSummary'].map(item => (
                            {
                                [item.label]: item.count
                            }))
                        console.log("MAPPED", timeStampSummaryMapped);
                        settimeSummary(Object.assign({}, ...timeStampSummaryMapped));
                        debugger;
                        // var result = res.result['timeStampSummary'].filter(item => item.label)
                    }
                    else {
                        debugger;
                    }
                })
                .catch((err) => {
                    debugger;
                    if (err.data.status == "error") {
                        debugger;
                    }
                })
        }
    }

    const addReasons = (e, key) => {
        if (e.target.checked) {
            classCancelReasons.push({
                id: key,
                reason: e.target.value,
            })
        }
        else {
            var a = classCancelReasons.filter(item => item.id !== key);
            setclassCancelReasons(a);
        }
    }
    const snackBarFunction = () => {
        var x = document.getElementById("snackbar");
        x.className = "show";
        setTimeout(function () {
            x.className = x.className.replace("show", "");
        }, 3000);
    };
    const submitReasons = () => {
        setbtnLoader(true)
        props.submitClassCancelReasons(programId, teacherId, classCancelReasons, studentsArray, courseId)
            .then((res) => {
                setsnackbarMessage("Class Cancel Message Sent");
                setsnackbarColor("#01ac8a")
                setsnackbar(true);
                setbtnLoader(false);
                setTimeout(function () {
                    setsnackbar(false);
                }, 3000);
                $('#ModalNotTakeClass').modal('hide');
            })
            .catch((err) => {
                debugger;
            })
    }
    console.log("Class Start Data", classStartData);
    console.log("History", timeStampHistory);
    console.log("Summary", timeSummary);
    console.log("Classes Info", classesInfo);
    console.log("Making Array", makingArray);
    console.log("Class Cancel Reasons", JSON.stringify(classCancelReasons));
    console.log("Students Array", studentsArray);
    return (
        // We are using this component for Class Start
        <div className="classStart">
            <div className={snackbar ? "show" : ""} id="snackbar" style={{ backgroundColor: snackbarColor }}>{snackbarMessage}</div>
            <div className="row">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="modalForZoomLink">
                                <div class="modal fade" tabindex="-1" role="dialog" id="myModal">
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                        <div class="modal-content">
                                            <div class="">
                                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div class="modal-body">
                                                <div className="text-center">
                                                    <label className="font-weight-bold"><i className="fas fa-link mr-3"></i>Paste Zoom Link here </label>
                                                    <input type="text" value={zoomLink} className="form-control" onChange={(e) => setzoomLink(e.target.value)} ></input>
                                                </div>
                                                <div className="text-center justify-content-center">
                                                    <button className="btn btn-lg modalSubmitBtn" onClick={() => submitZoom()}>Submit</button>
                                                </div>
                                            </div>
                                            {/* <div class="modal-footer">
                                                <button type="button" class="btn btn-primary" onClick={() => doFiler(43, 3)}>Save changes</button>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modalForZoomLink">
                                <div class="modal fade" tabindex="-1" role="dialog" id="myModalWait" data-backdrop="static" data-keyboard="false">
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                        <div class="modal-content">
                                            <div class="modal-body">
                                                <div className="text-center">
                                                    <label className="" style={{ fontSize: 18 }}>Zoom will be intitiated in </label>
                                                    <br />
                                                    {timerComponents}
                                                </div>
                                                <div className="text-center mt-5">
                                                    <div className="spinner-border" role="status">
                                                        <span className="sr-only">Loading...</span>
                                                    </div>
                                                </div>
                                                <div className="text-center justify-content-center mt-5 text-danger font-weight-bold">
                                                    <label>Do not close this window</label>
                                                </div>
                                            </div>
                                            {/* <div class="modal-footer">
                                                <button type="button" class="btn btn-primary" onClick={() => doFiler(43, 3)}>Save changes</button>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modalForZoomLink">
                                <div class="modal fade" tabindex="-1" role="dialog" id="ModalNotTakeClass" data-backdrop="static" data-keyboard="false">
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                        <div class="modal-content">
                                            <div class="modal-body">
                                                <div className="text-left">
                                                    <label className="font-weight-bold">Reasons for not taking the classes: </label>
                                                    <div className="p-3">
                                                        <div className="form-check">
                                                            <input className="form-check-input" onChange={(e) => addReasons(e, 1)} type="checkbox" name={""} value="Because of electricity breakdown" />
                                                            <label className="form-check-label" for="inlineRadio1">Because of electricity breakdown</label>
                                                        </div>
                                                        <div className="form-check">
                                                            <input className="form-check-input" onChange={(e) => addReasons(e, 2)} type="checkbox" name={""} value="Because of health issues" />
                                                            <label className="form-check-label" for="inlineRadio1">Because of health issues</label>
                                                        </div>
                                                        <div className="form-check">
                                                            <input className="form-check-input" onChange={(e) => addReasons(e, 3)} type="checkbox" name={""} value="Because of a minor emergency" />
                                                            <label className="form-check-label" for="inlineRadio1">Because of a minor emergency</label>
                                                        </div>
                                                        <div className="form-check">
                                                            <input className="form-check-input" onChange={(e) => addReasons(e, 4)} type="checkbox" name={""} value="Because of internet outage" />
                                                            <label className="form-check-label" for="inlineRadio1">Because of internet outage</label>
                                                        </div>
                                                        <div className="form-check">
                                                            <input className="form-check-input" onChange={(e) => addReasons(e, 5)} type="checkbox" name={""} value="Because of death in the family" />
                                                            <label className="form-check-label" for="inlineRadio1">Because of death in the family</label>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div class="modal-footer">
                                                <button type="button" className="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                                                <button type="button" disabled={btnLoader} className="btn btn-success btn-sm" onClick={() => submitReasons()}>Notify Parent</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {classesInfo.length ?
                                <div className="history" style={{ background: "#ffc1c5" }}>
                                    <h5>Alert:</h5>

                                    <ol>
                                        {classesInfo.length ? classesInfo.map((item, index) =>
                                            item.label === 0 ?
                                                <React.Fragment>
                                                    <li key={index} className="mt-2">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <label className="text-dark mt-1">What happened to the class on {item.timestamped} ? </label>
                                                            </div>

                                                            <div className="col-md-4 text-left">
                                                                <select className="form-control" name="year" onChange={(e) => doFiler(e, item.time_id)}>
                                                                    <option value="">Select Action</option>
                                                                    <option value="3">I did not teach this class</option>
                                                                    <option value="4">I forgot to click "Start Class" button</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        {/* <button className="btn btn-danger btn-sm" onClick={e => takeAction(item.time_id, 3)}>I did not teach this class</button>
                                                <button className="btn btn-warning btn-sm" onClick={e => takeAction(item.time_id, 4)}>I forgot to click "Start Class" button</button> */}
                                                    </li>
                                                    {/* <hr /> */}
                                                </React.Fragment>
                                                : null
                                        ) : <label className="p-2">No data</label>}
                                    </ol>
                                    {/* <ol>
                                    {classesInfo.length ? classesInfo.map((item, index) =>
                                        item.label === 0 ?
                                            <li key={index} className="mt-2"> <label className="text-dark">What happened to the class on {item.timestamped} </label> <button className="btn btn-danger btn-sm" onClick={e => takeAction(item.time_id, 3)}>I did not teach this class</button> <button className="btn btn-warning btn-sm" onClick={e => takeAction(item.time_id, 4)}>I forgot to click "Start Class" button</button> </li>
                                            : null
                                    ) : <label className="p-2">No data</label>}
                                </ol> */}
                                </div>
                                : null}

                            <div className="history mt-0" style={{ borderTop: "1px solid #c8d1dd" }}>
                                {!loading ? apiError === '' ?
                                    <React.Fragment>
                                        {timerComponents.length ? <React.Fragment> <label className="mt-2"> <span style={{ fontSize: 14 }}> Class Time: {classStartData.start} </span> {timerComponents} <br /> <br /> Are you ready to start the class</label>  </React.Fragment>
                                            : <span> <span style={{ fontSize: 14 }}> Class Time: {classStartData.start}  </span> <br /> <br /> You are <span className="font-weight-bold text-danger"> late! </span> Please start the class now (or it will be marked as <span className="font-weight-bold" style={{ color: "#7a7a7a" }}> missed </span>).</span>}
                                        <button className={startButton ? "ml-2 btn disabled" : "ml-2 btn notDisabled"} disabled={startButton} onClick={postTime}>Yes</button>

                                        <button data-toggle="modal" data-target="#ModalNotTakeClass" className={"ml-2 btn notTakeClass"}>I can not take this class today</button>

                                        <br />
                                        {zoomLink && zoomLink ?
                                            <React.Fragment>
                                                <label className="mt-3"> Zoom link for this class: <span className="text-info">{zoomLink}</span></label>
                                                <br />
                                                <span className="text-info font-weight-bold" data-toggle="modal" data-target="#myModal">(Click here to update zoom link)</span>
                                            </React.Fragment>
                                            :
                                            <label className="mt-3 font-weight-bold text-danger">No Zoom link found <span className="text-info font-italic" data-toggle="modal" data-target="#myModal">(Click here to add zoom link)</span></label>
                                        }
                                    </React.Fragment>
                                    : <label>{apiError}</label> : <div className="text-center"> <div className="spinner-border" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div> </div>}
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className="history">
                                <div className="d-flex justify-content-between">
                                    <h5>Which classes were started on time</h5>
                                    <select className="form-select ml-2" name="year" onChange={historyFilter}>
                                        <option value="week">This Week</option>
                                        <option value="month">This Month</option>
                                        <option value="all">All</option>
                                    </select>
                                </div>
                                <hr />
                                <div className="row">
                                    <div className="col">
                                        {timeStampHistory.length ? timeStampHistory.map((item, index) => {
                                            return <div className="historyRow" key={index}>
                                                {/* <React.Fragment>
                                                       <span className={item.label === 1 ? "lineOnTime" : item.label === 2 ? "lineLate" : item.label === 3 ? "lineMissed" : item.label === 4 ? "lineForgot" : null}></span>
                                                       <label>{item.timestamped} class started {item.label === 1 ? <span className="onTime">on time</span> : item.label === 2 ? <span className="late">late by {item.diff_time} mins</span> : item.label === 3 ? <span className="missed">missed</span> : item.label === 4 ? <span className="forgot">forgot</span> : null}</label>
                                                    </React.Fragment> */}
                                                {item.label === 1 ?
                                                    <React.Fragment>
                                                        <span className="lineOnTime"></span>
                                                        <label>{item.timestamped} class started <span className="onTime">on time</span> </label>
                                                    </React.Fragment>
                                                    : item.label === 2 ?
                                                        <React.Fragment>
                                                            <span className="lineLate"></span>
                                                            <label>{item.timestamped} class started <span className="late">late by {item.diff_time} mins</span> </label>
                                                        </React.Fragment>
                                                        : item.label === 3 ?
                                                            <React.Fragment>
                                                                <span className="lineMissed"></span>
                                                                <label>{item.timestamped} class <span className="missed">missed</span> </label>
                                                                {/* <button data-toggle="collapse" href={`#multiCollapseExample1${index}`} role="button" aria-expanded="false" aria-controls="multiCollapseExample1" className="btn btn-sm float-right reScheduleBtn">Reschedule</button>
                                                                <div class="collapse multi-collapse" id={`multiCollapseExample1${index}`}>
                                                                    <div class="card card-body">
                                                                        <label>Select a date to schedule a compensatory class</label>
                                                                    </div>
                                                                </div> */}
                                                            </React.Fragment>
                                                            : item.label === 4 ?
                                                                <React.Fragment>
                                                                    <span className="lineForgot"></span>
                                                                    <label>{item.timestamped} class <span className="forgot">forgot</span> </label>
                                                                </React.Fragment>
                                                                : null
                                                }
                                            </div>
                                        }) : <div className="text-center">
                                                No Data
                                         </div>}
                                        {/* <div className="historyRow">
                                            <span className="lineOnTime"></span>
                                            <label>Thursday 25th July class started <span className="onTime">on time</span></label>
                                        </div>
                                        <div className="historyRow">
                                            <span className="lineLate"></span>
                                            <label>Wednesday 24th July class started <span className="late">late by 2 min</span></label>
                                        </div>
                                        <div className="historyRow">
                                            <span className="lineOnTime"></span>
                                            <label>Tuesday 23rd July class started <span className="onTime">on time</span></label>
                                        </div>
                                        <div className="historyRow">
                                            <span className="lineLate"></span>
                                            <label>Monday 24th July class started <span className="late">late by 2 min</span></label>
                                        </div>
                                        <div className="historyRow">
                                            <span className="lineMissed"></span>
                                            <label>Friday 22nd July class  <span className="missed">missed</span></label>
                                        </div>
                                        <div className="historyRow">
                                            <span className="lineOnTime"></span>
                                            <label>Thursday 21st July class started <span className="onTime">on time</span></label>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className="history">
                                <h5 className="mb-4">Summary of class commencement</h5>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">Started</th>
                                            <th scope="col">{filter === "all" ? "All" : filter === "week" ? "This Week" : filter === "month" ? "This Month" : null}</th>
                                            <th scope="col">History</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="ontimeRow">On Time</td>
                                            <td>{typeof timeSummary[1] !== 'undefined' ? `${timeSummary[1]} times` : "none"}</td>
                                            <td>{typeof overAllSummary[1] !== 'undefined' ? `${overAllSummary[1]} times` : "none"}</td>
                                        </tr>

                                        <tr >
                                            <td className="lateRow">Late</td>
                                            <td>{typeof timeSummary[2] !== 'undefined' ? `${timeSummary[2]} times` : "none"}</td>
                                            <td>{typeof overAllSummary[2] !== 'undefined' ? `${overAllSummary[2]} times` : "none"}</td>
                                        </tr>

                                        <tr>
                                            <td className="missedRow">Missed</td>
                                            <td>{typeof timeSummary[3] !== 'undefined' ? `${timeSummary[3]} times` : "none"}</td>
                                            <td>{typeof overAllSummary[3] !== 'undefined' ? `${overAllSummary[3]} times` : "none"}</td>
                                        </tr>

                                        <tr>
                                            <td className="forgotRow">Forgot</td>
                                            <td>{typeof timeSummary[4] !== 'undefined' ? `${timeSummary[4]} times` : "none"}</td>
                                            <td>{typeof overAllSummary[4] !== 'undefined' ? `${overAllSummary[4]} times` : "none"}</td>
                                        </tr>
                                    </tbody>
                                    {/* <tbody>
                                        {timeSummary.map((item, index) =>
                                            item.label === 1 ?
                                                <tr key={index}>
                                                    <td className="ontimeRow">On Time</td>
                                                    <td>{item.count} times</td>
                                                    <td>{overAllSummary[1]} times</td>
                                                </tr>
                                                : item.label === 2 ?
                                                    <tr key={index}>
                                                        <td className="lateRow">Late</td>
                                                        <td>{item.count} times</td>
                                                        <td>{overAllSummary[2]} times</td>
                                                    </tr>
                                                    : item.label === 3 ?
                                                        <tr key={index}>
                                                            <td className="missedRow">Missed</td>
                                                            <td>{item.count} times</td>
                                                            <td>{overAllSummary[3]} times</td>
                                                        </tr>
                                                        : item.label === 4 ?
                                                            <tr key={index}>
                                                                <td className="forgotRow">Forgot</td>
                                                                <td>{item.count} times</td>
                                                                <td>{overAllSummary[4]} times</td>
                                                            </tr>
                                                            : null
                                        )}
                                    </tbody> */}
                                </table>
                                {/* <table className="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">Started</th>
                                            <th scope="col">This Month</th>
                                            <th scope="col">History</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="ontimeRow">On Time</td>
                                            <td>3 times</td>
                                            <td>50 times</td>
                                        </tr>
                                        <tr>
                                            <td className="lateRow">Late</td>
                                            <td>1 times</td>
                                            <td>7 times</td>
                                        </tr>
                                        <tr>
                                            <td className="missedRow">Missed</td>
                                            <td>1 times</td>
                                            <td>6 times</td>
                                        </tr>
                                        <tr>
                                            <td className="forgotRow">I Forgot</td>
                                            <td>none</td>
                                            <td>8 times</td>
                                        </tr>
                                    </tbody>
                                </table> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        programNameState: state.feedTutorRed.programName,
        classStartTime: state.feedTutorRed.classStartTime
    };
}
export default connect(mapStateToProps, { getClassStartTime, sendStartTime, getClassSummary, sendActions, submitZoomLinkForClassStart, submitClassCancelReasons })(ClassStart2);